import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaxesService {

  constructor(private api: ApiService) { }

  getAllTaxe(data: any): Observable<any> {
    return this.api.post(environment.getAllTaxe, data);
  }

  deleteTaxe(data: any): Observable<any> {
    return this.api.post(environment.deleteTaxe, data);
  }

  createTaxe(data: any): Observable<any> {
    return this.api.post(environment.createTaxe, data);
  }

  updateTaxe(data: any): Observable<any> {
    return this.api.post(environment.updateTaxe, data);
  }

}
